import React from 'react'

const Cross = () => {
  return (
    <svg 
      xmlns="http://www.w3.org/2000/svg" 
      width="17" 
      height="17" 
      viewBox="0 0 17 17" 
      fill="none"
    >
      <path 
        d="M1.14209 15.1421L15.2842 1" 
        stroke="#D2BEB5" 
        strokeWidth="2" 
        strokeLinecap="round"
      />
      <path 
        d="M15.1421 15.1421L0.999954 1" 
        stroke="#D2BEB5" 
        strokeWidth="2" 
        strokeLinecap="round"/>
    </svg>
  )
}

export default Cross